import script from "./DataProviderEntityFieldRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataProviderEntityFieldRow.vue?vue&type=script&lang=ts&setup=true"

import "./DataProviderEntityFieldRow.vue?vue&type=style&index=0&id=954bd7da&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-954bd7da"]])

export default __exports__